// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentServiceStatusModel {
    static getAttributeTypeMap() {
        return EnrollmentServiceStatusModel.attributeTypeMap;
    }
}
EnrollmentServiceStatusModel.discriminator = undefined;
EnrollmentServiceStatusModel.attributeTypeMap = [
    {
        "name": "timestampLocal",
        "baseName": "timestampLocal",
        "type": "Date"
    },
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "timestampUtc",
        "baseName": "timestampUtc",
        "type": "Date"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "properties",
        "baseName": "properties",
        "type": "{ [key: string]: string; }"
    }
];
//# sourceMappingURL=enrollmentServiceStatusModel.js.map